import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  html {
    overflow-y: scroll;
    scrollbar-gutter: stable;
  }

  /* Thin, discrete scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }

  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  }

  /* Onboarding "ping" — pulses whichever card the user was just sent to from
     an onboarding step, so the one thing they have to act on is unmissable.
     Global (not per-page) because several pages ping different cards.
     Uses outline, not border, so it neither shifts layout nor has to out-
     specify the card's own styles; the animated box-shadow already beats
     static declarations in the cascade. */
  @keyframes tfSetupPing {
    0% { box-shadow: 0 0 0 0 rgba(41, 35, 89, 0.3); }
    70% { box-shadow: 0 0 0 12px rgba(41, 35, 89, 0); }
    100% { box-shadow: 0 0 0 0 rgba(41, 35, 89, 0); }
  }

  .tf-setup-ping {
    outline: 1.5px solid ${({ theme }) => theme.colors.accent[500]};
    outline-offset: -1.5px;
    animation: tfSetupPing 1.7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    .tf-setup-ping {
      animation: none;
    }
  }

  /* sweetalerts global design styles */
  .swal-modal {
    max-width: 500px;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: ${({ theme }) => theme.shadows.card};
    border-radius: ${({ theme }) => theme.radius[8]};
    overflow: hidden;
  }

  .swal-title {
    padding: ${({ theme }) => theme.spacing[24]};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin: 0 !important;
  }

  .swal-text {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: 17px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    padding: 0 ${({ theme }) => theme.spacing[24]} ${({ theme }) => theme.spacing[24]} ${({ theme }) => theme.spacing[24]};
    text-align: center;
  }

  .swal-footer {
    padding: 0 !important;
    display: flex;
  }

  .swal-button-container {
    width: 50%;
    margin: 0 !important;
  }

  .swal-button {
    width: 100%;
    height: 50px;
    border-radius: 0;
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .swal-button--cancel {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  }

  .swal-button--danger {
    color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
    background: ${({ theme }) => theme.colors.error[500]};
  }

  .swal-button--cancel:focus {
    box-shadow: none !important;
  }
`;

export default GlobalStyles;
